import type { PublicQuote } from "./types";
export function selectionTotals(quote: PublicQuote, selected: string[]) {
  const subtotal = quote.sections.filter(s => !s.is_optional || selected.includes(s.id ?? "")).reduce((n, s) => n + s.amount_cents, 0);
  const tax = Math.round(subtotal * (quote.tax_rate_bp ?? 1000) / 10000);
  const depositEx = Math.round(subtotal * (quote.deposit_percent ?? 0) / 100);
  return { subtotal, tax, total: subtotal + tax, deposit: depositEx + Math.round(depositEx * (quote.tax_rate_bp ?? 1000) / 10000) };
}
